import React, {useContext} from "react";
import {BoShowContext} from "../context/bo-show-context.jsx";

const BoShowLastSignature = () => {
    const {dataFetch, verifySyncUrl, printOptions} = useContext(BoShowContext);
    const lastApprovalSignature = dataFetch?.bogcm?.lastApprovalSignature;
    const lastApprovalUserName = dataFetch?.bogcm?.lastApprovalUserName ?? "Responsável";

    return (
        <article className={"pt-8 hidden" + (printOptions.approvalSignature ? "print:block" : "")}>
            {
                lastApprovalSignature &&
                <div className={"image max-w-xs ms-auto"}>
                    <img src={`${verifySyncUrl(lastApprovalSignature)}/${lastApprovalSignature}`} alt={lastApprovalUserName}/>
                </div>
            }

            <p className={"line-leader-signature text-center max-w-xs ms-auto"}>{lastApprovalUserName}</p>
        </article>
    );
};

export default BoShowLastSignature;
